export const BATCH_ACTIONS = 'BATCH_ACTIONS';

export const START_LOADING_SESSION = 'session/load/start';
export const END_LOADING_SESSION = 'session/load/end';
export const START_LOGGING_IN = 'session/login/start';
export const END_LOGGING_IN = 'session/login/end';

export const USER_SET = 'user/set';
export const USER_UNSET = 'user/unset';
export const USER_CLONE = 'user/clone';
export const USER_LOAD = 'user/load';
export const USER_RELOAD = 'user/reload';
export const USER_LOAD_CFG_ITEM = 'user/cfgItem/load';
export const USER_SAVE_CFG_ITEM = 'user/cfgItem/save';
export const USER_SWITCH_APPLICATION = 'user/application/switch';
export const USER_RELOAD_PERMISSIONS = 'user/permissions/reload';
export const USER_SET_LANGUAGE = 'user/setLanguage';
export const USER_SET_VIEWS_FOR_MODULE = 'user/setViewsForModule';
export const USER_SET_EMAIL = 'user/setEmail';
export const USER_SET_FIRSTNAME = 'user/setFirstName';
export const USER_SET_LASTNAME = 'user/setLastName';
export const USER_SET_VIEW_TO_OPEN_BY_DEFAULT = 'user/setViewToOpenByDefault';
export const USER_SET_TAB_BAR_POSITION = 'user/setTabBarPosition';

export const AJAX_START = 'ajax/request/start';
export const AJAX_END = 'ajax/request/end';
export const CANCEL_AJAX_REQUEST = 'ajax/request/cancel';
export const CANCEL_AJAX_REQUESTS = 'ajax/request/cancelAll';
export const AJAX_ERROR = 'ajax/error';
export const CLEAR_AJAX_ERROR = 'ajax/error/clear';
export const CLEAR_AJAX_ERROR_SUBPANELS = 'ajax/error/subPanels/clear';

export const SET_GLOBAL_MASK = 'globalMask/set';
export const CLEAR_GLOBAL_MASK = 'globalMask/clear';

export const CONFIG_LOAD = 'config/load';
export const CONFIG_RELOAD = 'config/reload';
export const CONFIG_RECEIVE = 'config/receive';

export const DATACHANGEEVENTS_RELOAD = 'dataChangeEvents/reload';

export const METAMODEL_LOAD = 'metaModel/load';
export const METAMODEL_RELOAD = 'metaModel/reload';
export const METAMODEL_RECEIVE = 'metaModel/receive';

export const MESSAGECATALOG_LOAD = 'messageCatalog/load';
export const MESSAGECATALOG_RELOAD = 'messageCatalog/reload';
export const MESSAGECATALOG_RECEIVE = 'messageCatalog/receive';
export const MESSAGECATALOG_SET_LANGUAGE = 'messageCatalog/setLanguage';

export const RECEIVE_BACKEND_STATE = 'backend/state/receive';

export const LOAD_DATA = 'data/load';
export const SAVE_DATA = 'data/save';
export const DATA_ADD_ITEM = 'data/item/add';
export const DATA_UPDATE_ITEM = 'data/item/update';
export const DATA_DELETE_ITEM = 'data/item/delete';
export const DATA_RESET_ITEM = 'data/item/reset';
export const DATA_ADD_REFERENCE = 'data/reference/add';
export const DATA_UPDATE_REFERENCE = 'data/reference/update';
export const DATA_DELETE_REFERENCE = 'data/reference/delete';

export const ELUSIVEDATA_SET = 'elusiveData/set';
export const ELUSIVEDATA_UNSET = 'elusiveData/unset';
export const ELUSIVEDATA_CLEAR = 'elusiveData/clear';
export const ELUSIVEDATA_CLEAR_ALL = 'elusiveData/clearAll';
export const ELUSIVEDATA_CLEAR_SUBPANELS = 'elusiveData/subPanels/clear';

export const IC_SET_MESSAGE = 'intercom/message/set';
export const IC_UNSET_MESSAGE = 'intercom/message/unset';
export const IC_UNSET_ALL_MESSAGES = 'intercom/message/unsetAll';

export const PANELMANAGER_OPEN_POPUP = 'panelManager/popup/open';
export const PANELMANAGER_CLOSE_POPUP = 'panelManager/popup/close';
export const PANELMANAGER_CLOSE_POPUP_FINISH = 'panelManager/popup/closeFinish';
export const PANELMANAGER_OPEN_PANEL = 'panelManager/panel/open';
export const PANELMANAGER_OPEN_PANEL_DENIED = 'panelManager/panel/openDenied';
export const PANELMANAGER_OPEN_PANEL_FOR_ITEMTYPE = 'panelManager/panel/openPanelForItemType';
export const PANELMANAGER_CLOSE_PANEL = 'panelManager/panel/close';
export const PANELMANAGER_CLOSE_PANEL_FINISH = 'panelManager/panel/closeFinish';
export const PANELMANAGER_ACTIVATE_PANEL = 'panelManager/panel/activate';
export const PANELMANAGER_SAVE_PANEL = 'panelManager/panel/save';
export const PANELMANAGER_MOVE_PANEL = 'panelManager/panel/move';
export const PANELMANAGER_CONFIRM_CLOSE_PANEL = 'panelManager/panel/confirmClose';
export const PANELMANAGER_SHOW_CONFIRMCLOSEDIALOG = 'panelManager/panel/confirmClose/showDialog';
export const PANELMANAGER_HIDE_CONFIRMCLOSEDIALOG = 'panelManager/panel/confirmClose/hideDialog';
export const PANELMANAGER_SHOW_DELETESUCCESSDIALOG = 'panelManager/panel/deleteSuccess/showDialog';
export const PANELMANAGER_HIDE_DELETESUCCESSDIALOG = 'panelManager/panel/deleteSuccess/hideDialog';
export const PANELMANAGER_CLEAR_PANELPROPS = 'panelManager/panel/props/clear';
export const PANELMANAGER_SET_PANELPROPS = 'panelManager/panel/props/set';
export const PANELMANAGER_SHOW_PANELPROPSDIALOG = 'panelManager/panel/props/showDialog';
export const PANELMANAGER_HIDE_PANELPROPSDIALOG = 'panelManager/panel/props/hideDialog';
export const PANELMANAGER_SET_PANELPROPS_VALIDATIONERROR = 'panelManager/panel/props/setValidationError';
export const PANELMANAGER_CLEAR_PANELPROPS_VALIDATIONERROR = 'panelManager/panel/props/clearValidationError';
export const PANELMANAGER_SET_PANEL_INFO = 'panelManager/panel/setPanelInfo';
export const PANELMANAGER_SET_PANEL_TITLE_AND_ICON = 'panelManager/panel/setTitleAndIcon';
export const PANELMANAGER_SET_PANEL_TITLE = 'panelManager/panel/setTitle';
export const PANELMANAGER_SET_PANEL_ICON = 'panelManager/panel/setIcon';
export const PANELMANAGER_SET_PANEL_TOOLTIP = 'panelManager/panel/setPanelTooltip';
export const PANELMANAGER_SET_PANEL_DIRTY = 'panelManager/panel/setDirty';
export const PANELMANAGER_SET_PANEL_INVALID = 'panelManager/panel/setInvalid';
export const PANELMANAGER_SET_PANEL_PATH = 'panelManager/panel/setPath';
export const PANELMANAGER_SET_SCROLLPOSITION = 'panelManager/setScrollPosition';

export const PPD_SET_ACTIVE_TAB = 'PPD_SET_ACTIVE_TAB';
export const PPD_CLEAR_STATE = 'PPD_CLEAR_STATE';

export const PANEL_SET_PARAM = 'panel/param/set';
export const PANEL_UNSET_PARAM = 'panel/param/unset';
export const PANEL_SET_PARAMS = 'panel/params/set';

export const DATATABLE_SET_PAGINATION_DATA = 'dataTable/setPaginationData';
export const DATATABLE_SAVE_DATA = 'dataTable/saveData';
export const DATATABLE_CLEAR_SEARCH = 'dataTable/search/clear';
export const DATATABLE_RESET_SEARCH = 'dataTable/search/reset';
export const DATATABLE_DO_SEARCH = 'dataTable/search/do';

export const FINDER_OVERVIEW_INITIALIZE = 'finderOverview/initialize';
export const FINDER_OVERVIEW_CLEAR_SEARCH = 'finderOverview/clearSearch';
export const FINDER_OVERVIEW_SET_SCHEMA = 'finderOverview/setSchema';
export const FINDER_OVERVIEW_SET_ITEMTYPENAME = 'finderOverview/setItemType';
export const FINDER_OVERVIEW_SET_ADVANCED_SEARCH_OPTIONS = 'finderOverview/setAdvancedSearchOptions';

export const FINDER_DETAIL_LOAD_DATA = 'finderDetail/data/load';
export const FINDER_DETAIL_SAVE_DATA = 'finderDetail/data/save';
export const FINDER_DETAIL_SET_ADVANCED_SEARCH_OPTIONS = 'finderDetail/setAdvancedSearchOptions';

export const OVERVIEW_CLEAR_SEARCH = 'overview/clearSearch';

export const FORM_LOAD_DATA = 'form/data/load';
export const FORM_LOAD_DATA_FOR_DATASTRUCTURE = 'form/data/loadForDataStructure';
export const FORM_SAVE_DATA = 'form/data/save';

export const CHARTDESIGNER_DELETE_CHART = 'chartDesigner/delete';
export const CHARTDESIGNER_LOAD_DATA_FOR_DATASTRUCTURE = 'chartDesigner/data/loadForDataStructure';
export const CHARTDESIGNER_LOAD_DATA_FOR_QUERY = 'chartDesigner/data/loadForQuery';

export const FORMDESIGNER_DELETE_FORM = 'formDesigner/delete';

export const OVERVIEWDESIGNER_DELETE_OVERVIEW = 'overviewDesigner/delete';
export const OVERVIEWDESIGNER_LOAD_DATA_FOR_DATASTRUCTURE = 'overviewDesigner/data/loadForDataStructure';
export const OVERVIEWDESIGNER_LOAD_DATA_FOR_QUERY = 'overviewDesigner/data/loadForQuery';

export const BUSINESSPROCESSDESIGNER_DELETE_BUSINESSPROCESS = 'businessProcessDesigner/delete';

export const TREEVIEWDESIGNER_DELETE_BUSINESSPROCESS = 'treeViewDesigner/delete';

export const MAPSEARCH_DELETE_MAPSEARCH = 'mapSearch/delete';

export const REQUEST_TREE_DATA = 'REQUEST_TREE_DATA';
export const RECEIVE_TREE_DATA = 'RECEIVE_TREE_DATA';

export const TREE_SET_TEMPDATA = 'TREE_SET_TEMPDATA';
export const TREE_UNSET_TEMPDATA = 'TREE_UNSET_TEMPDATA';

export const DEBUG_SHOW_DEVTOOLS = 'debug/devTools/show';
export const DEBUG_HIDE_DEVTOOLS = 'debug/devTools/hide';
export const DEBUG_SHOW_MEMCONSUMPTION = 'debug/memConsumption/show';
export const DEBUG_HIDE_MEMCONSUMPTION = 'debug/memConsumption/hide';
export const DEBUG_ENABLE_FORM_DEBUG_ALL = 'debug/formDebug/enable';
export const DEBUG_DISABLE_FORM_DEBUG_ALL = 'debug/formDebug/disable';
export const DEBUG_ADD_DEDICATED_FORM_DEBUG = 'debug/formDebug/dedicated/add';
export const DEBUG_REMOVE_DEDICATED_FORM_DEBUG = 'debug/formDebug/dedicated/remove';
export const DEBUG_ENABLE_DEDICATED_FORM_DEBUG = 'debug/formDebug/dedicated/enable';
export const DEBUG_DISABLE_DEDICATED_FORM_DEBUG = 'debug/formDebug/dedicated/disable';
export const DEBUG_ENABLE_FORMDESIGNER_DEBUG_ALL = 'debug/formDesignerDebug/enable';
export const DEBUG_DISABLE_FORMDESIGNER_DEBUG_ALL = 'debug/formDesignerDebug/disable';
export const DEBUG_ADD_DEDICATED_FORMDESIGNER_DEBUG = 'debug/formDesignerDebug/dedicated/add';
export const DEBUG_REMOVE_DEDICATED_FORMDESIGNER_DEBUG = 'debug/formDesignerDebug/dedicated/remove';
export const DEBUG_ENABLE_DEDICATED_FORMDESIGNER_DEBUG = 'debug/formDesignerDebug/dedicated/enable';
export const DEBUG_DISABLE_DEDICATED_FORMDESIGNER_DEBUG = 'debug/formDesignerDebug/dedicated/disable';
export const DEBUG_ENABLE_DATATABLE_DEBUG_ALL = 'debug/dataTableDebug/enable';
export const DEBUG_DISABLE_DATATABLE_DEBUG_ALL = 'debug/dataTableDebug/disable';
export const DEBUG_ADD_DEDICATED_DATATABLE_DEBUG = 'debug/dataTableDebug/dedicated/add';
export const DEBUG_REMOVE_DEDICATED_DATATABLE_DEBUG = 'debug/dataTableDebug/dedicated/remove';
export const DEBUG_ENABLE_DEDICATED_DATATABLE_DEBUG = 'debug/dataTableDebug/dedicated/enable';
export const DEBUG_DISABLE_DEDICATED_DATATABLE_DEBUG = 'debug/dataTableDebug/dedicated/disable';
export const DEBUG_ENABLE_WEBSOCKET_DEBUG = 'debug/webSocket/enable';
export const DEBUG_DISABLE_WEBSOCKET_DEBUG = 'debug/webSocket/disable';
export const MESSAGE_CLEAR_ALERT = 'message/clearAlertMessage';
export const MESSAGE_SET_ALERT = 'message/setAlertMessage';
export const XMLIMPORT_UPLOAD_DATA = 'xmlImport/data/upload';
